module.exports = __webpack_public_path__ + "static/media/ma.314d5b13.svg";